var $73f50e845f9ef3b4$exports = {};
$73f50e845f9ef3b4$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " niet geselecteerd.");
  },
  "longPressToSelect": "Druk lang om de selectiemodus te openen.",
  "select": "Selecteren",
  "selectedAll": "Alle items geselecteerd.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Geen items geselecteerd",
      one: function one() {
        return "".concat(formatter.number(args.count), " item geselecteerd");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " items geselecteerd");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " geselecteerd.");
  }
};
export { $73f50e845f9ef3b4$exports as default };